import { useQuery } from "@tanstack/react-query";
import type { ShiftInspectionsResult } from "../../models/Inspection";
import { getInspectionsByShift } from "../../repositories/InspectionRepository";

interface UseShiftInspectionsQueryProps {
	assetId: number;
	shiftId: number | null;
	startDate: Date | null;
	endDate: Date | null;
	sectionId: number | null;
	heatId: number | null;
	enabled?: boolean;
	onError?: (error: Error) => void;
}

export const useShiftInspectionsQuery = ({
	enabled = true,
	onError,
	...params
}: UseShiftInspectionsQueryProps) =>
	useQuery<ShiftInspectionsResult, Error>({
		queryKey: [
			"test-shack-shift-inspections",
			params.assetId,
			params.shiftId,
			params.startDate?.getTime() ?? null,
			params.endDate?.getTime() ?? null,
			params.sectionId,
			params.heatId,
		],
		meta: { realtime: ["DIM.GetProfileInspectionsByShift"] },
		queryFn: ({ signal }) => getInspectionsByShift(params, signal),
		enabled,
		onError,
	});

interface UseShiftInspectionQueryProps {
	assetId: number;
	profileInspectionId: number | null;
	enabled?: boolean;
	onError?: (error: Error) => void;
}

export const useShiftInspectionQuery = ({
	enabled = true,
	onError,
	...params
}: UseShiftInspectionQueryProps) =>
	useQuery<ShiftInspectionsResult, Error>({
		queryKey: [
			"test-shack-shift-inspections",
			"detail",
			params.assetId,
			params.profileInspectionId,
		],
		meta: { realtime: ["DIM.GetProfileInspectionsByShift"] },
		queryFn: ({ signal }) => getInspectionsByShift(params, signal),
		enabled: enabled && params.profileInspectionId !== null,
		onError,
	});
